export default __webpack_public_path__ + "static/product1-ae7803d61e3bd2ff40b0767214202a28.png";